import ArtistsList from "./ArtistsList";
export default ArtistsList;
